export default __webpack_public_path__ + "d1b85cb2907acd224fed87c301e246bd.svg";